<template>
  <v-card class="pt-2 pb-4 mt-3">
    <v-toolbar flat color="white">
      <v-toolbar-title>Invitations</v-toolbar-title>
    </v-toolbar>

    <template v-if="$vuetify.breakpoint.smAndDown">
      <v-card v-for="invitation in invitations" :key="invitation.id" class="xs12 my-2">

      <v-card-title>
        <v-layout column>
          <h6 class="title text-truncate">
            {{invitation.email}}
          </h6>
        </v-layout>
      </v-card-title>

      <v-card-text>
        <b>Permissions:</b> {{invitation.companyPermissions ?
        invitation.companyPermissions.join(', ') : null}}<br/>
        <b>Created: </b> {{invitation.created | formatDate}} <br/>
        <b>Expiration: </b> {{invitation.expiration | formatDate}} <br/>
        <b>Invited By: </b> {{invitation.invitedBy}}<br/>
        <b>Status: </b>
          <v-chip color="success"
                  class="text-truncate"
                  v-if="invitation.user"
                  text-color="white">
            <span v-if="invitation.user.name">Accepted by {{invitation.user.name}}</span>
            <span v-else>Accepted</span>
          </v-chip>
          <v-chip color="accent"
                  v-else-if="hasExpired(invitation)"
                  text-color="white">
            Expired
          </v-chip>
          <v-chip v-else color="primary" text-color="white">
            Active
          </v-chip>
        <br />
      </v-card-text>
    </v-card>
    </template>
    <v-data-table v-if="$vuetify.breakpoint.smAndUp"
                  :headers="invitationsHeaders"
                  :pagination.sync="pagination"
                  disable-initial-sort
                  :items="invitations">
      <template slot="items" slot-scope="slotItems">
        <tr>
          <td>
            {{slotItems.item.email}}
          </td>
          <td>
            {{slotItems.item.companyPermissions ?
            slotItems.item.companyPermissions.join(', ') : ''}}
          </td>
          <td>
            {{slotItems.item.created | formatDate}}
          </td>
          <td>
            {{slotItems.item.expiration | formatDate}}
          </td>
          <td>
            {{slotItems.item.invitedBy}}
          </td>
          <td>
            <v-chip color="success"
                    v-if="slotItems.item.user"
                    text-color="white">
              <span v-if="slotItems.item.user.name">Accepted by {{slotItems.item.user.name}}</span>
              <span v-else>Accepted</span>
            </v-chip>
            <v-chip color="accent"
                    v-else-if="hasExpired(slotItems.item)"
                    text-color="white">
              Expired
            </v-chip>
            <v-chip v-else color="primary" text-color="white">
              Active
            </v-chip>
          </td>
        </tr>
      </template>
    </v-data-table >
  </v-card>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import API from '@/api';

export default {
  name: 'InvitationsSection',
  props: {
    company: {
      type: Object,
    },
  },
  data() {
    return {
      invitations: [],
      pagination: {
        sortBy: 'created',
        descending: true,
      },
      invitationsHeaders: [
        { text: 'Email', value: 'email', width: '1%' },
        { text: 'Permissions', value: 'companyPermissions', width: '1%' },
        { text: 'Created', value: 'created', width: '1%' },
        { text: 'Expiration', value: 'expiration', width: '1%' },
        { text: 'Invited By', value: 'invitedBy', width: '1%' },
        { text: 'Status', value: 'user', width: '1%' },
        { text: ''}
      ],
    };
  },
  methods: {
    hasExpired(invitation) {
      const expiration = moment(invitation.expiration, moment.ISO_8601);
      return expiration.isBefore(moment());
    },
    async loadInvitations() {
      const apiResponse = await API.company.getInvitations({
        companyId: this.company.id,
      });

      this.invitations = _.filter(apiResponse.data.invitations, invitation => !invitation.user);
    },
  },
  created() {
    this.loadInvitations();
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Companies/Sections/InvitationsSection.vue